import asCanvasElement from '../../utils/CanvasElement';
import TextElement from './TextElement';
import type { TextElementProps } from './types';

export type { TextElementProps };
export default asCanvasElement(TextElement);
